import React from "react";
import ReportManagementDetailTableRowColumn from "./ReportManagementDetailTableRowColumn";
import { ReportEfficacyDisplay } from "../../../components/ReportEfficacyDisplay";

export type ReportManagementDetailTableRowEfficacyColumnProps = {
    efficacy: number,
    size?: 
        | "xs"
        | "lg"
        | "sm"
        | "1x"
        | "2x"
        | "3x"
        | "4x"
        | "5x"
        | "6x"
        | "7x"
        | "8x"
        | "9x"
        | "10x",
    width?: string | number
};

const ReportManagementDetailTableRowEfficacyColumn = (
    { width = 5, efficacy, size = "lg" }: Readonly<ReportManagementDetailTableRowEfficacyColumnProps>
) => (
    <ReportManagementDetailTableRowColumn   ClientReportTableRowColumn width={width} className="text-center">
        <ReportEfficacyDisplay efficacy={efficacy} size={size} />
    </ReportManagementDetailTableRowColumn>
);

export default ReportManagementDetailTableRowEfficacyColumn;